export const IMAGE_TYPES = {
  "image/png": [".png"],
  "image/jpeg": [".jpeg", ".jpg"],
  "image/jpg": [".jpg"],
};

export const IMAGE_ERROR_NOTIFICATION =
  "Upload a valid image. The file you uploaded was either not an image or a corrupted image.";
